export default "__VITE_ASSET__CL9ALMqs__"